// import delegateEvent from './../utilities/delegateEvent';
import debounce from './../utilities/debounce';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const drawerItemsSelector = '[data-w-nav-items="drawer"] [data-w-nav-item-for]';
const barItemsSelector = '[data-w-nav-items="bar"] [data-w-nav-item-for]';

const setup = () => {
  const triggers = document.querySelectorAll('[data-w-nav-trigger]');

  const drawerItems = document.querySelectorAll(drawerItemsSelector);
  const barItems = document.querySelectorAll(barItemsSelector);

  const navScrollContainer = document.querySelector(
    '[data-w-nav-scroll-container]'
  );

  const navDrawerToggle = document.querySelector('[data-w-nav-drawer-toggle]');

  const isNavOpen = () =>
    document.documentElement.classList.contains('w-has-nav-open');

  const setActiveItem = (target, type) => {
    if (!target || !type) return;

    gsap.to(navScrollContainer, {
      duration: type === 'instant' ? 0 : 1,
      scrollTo: {
        y: target,
        offsetY: (window.innerHeight / 100) * 40, // 40lvh
        autoKill: true,
      },
      ease: 'power2',
    });

    if (type === 'drawer') navDrawerToggle.click();
  };

  [...drawerItems, ...barItems].forEach((item) => {
    const type = item.getAttribute('data-w-nav-item');

    item.addEventListener('click', () => {
      let target = item;
      if (type === 'bar') {
        const id = item.getAttribute('data-w-nav-item-for');
        target = document.querySelector(
          `[data-w-nav-items="drawer"] [data-w-nav-item-for="${id}"]`
        );
      }
      setActiveItem(target, type);
    });
  });

  triggers.forEach((trigger, index) => {
    const id = trigger.getAttribute('id');

    const drawerItem = document.querySelector(
      `[data-w-nav-items="drawer"] [data-w-nav-item-for="${id}"]`
    );

    let previousDrawerItem = null;
    if (drawerItem) {
      const drawerIndex = Array.from(drawerItems).findIndex(
        (element) => element === drawerItem
      );
      previousDrawerItem = drawerItems[drawerIndex - 1] ?? null;
    }

    const barItem = document.querySelector(
      `[data-w-nav-items="bar"] [data-w-nav-item-for="${id}"]`
    );
    let previousBarItem = null;
    if (barItem) {
      const barIndex = Array.from(barItems).findIndex(
        (element) => element === barItem
      );
      previousBarItem = barItems[barIndex - 1] ?? null;
    }

    gsap.to(trigger, {
      scrollTrigger: {
        // markers: true,
        trigger: trigger,
        start: 'top bottom',
        end: 'bottom bottom',
        fastScrollEnd: true,
        onEnter: () => {
          if (previousBarItem) previousBarItem.classList.remove('w-is-active');
          if (barItem) barItem.classList.add('w-is-active');

          if (previousDrawerItem)
            previousDrawerItem.classList.remove('w-is-active');
          if (drawerItem) {
            drawerItem.classList.add('w-is-active');
            if (!isNavOpen()) setActiveItem(drawerItem, 'instant');
          }

          if (index === 1) {
            document.documentElement.classList.add('w-has-navbar-visible');
          }
        },
        onEnterBack: () => {
          if (drawerItem && !isNavOpen()) setActiveItem(drawerItem, 'instant');

          if (index === triggers.length - 1) {
            document.documentElement.classList.add('w-has-navbar-visible');
          }
        },
        onLeave: () => {
          if (index === triggers.length - 1) {
            document.documentElement.classList.remove('w-has-navbar-visible');
          }
        },
        onLeaveBack: () => {
          if (barItem) barItem.classList.remove('w-is-active');
          if (previousBarItem) previousBarItem.classList.add('w-is-active');

          if (drawerItem) drawerItem.classList.remove('w-is-active');
          if (previousDrawerItem) {
            previousDrawerItem.classList.add('w-is-active');
          }

          if (index === 1) {
            document.documentElement.classList.remove('w-has-navbar-visible');
          }
        },
      },
    });
  });
};

export default function Navigation() {
  return {
    init: () => {
      setup();
    },
  };
}
